import styled, { css, keyframes } from 'styled-components';

import {
    CONTENT_DISABLED,
    CONTENT_MUTED,
    POSITIVE_BASE,
    PRIMARY_BASE,
    PRIMARY_DISABLED,
} from '@amzn/ring-common-style-library/lib/colors';
import { MessageParticipantRole } from '@amzn/ring-cs-chatbot-service-model';

const growToBarRight = (width: number) => keyframes`
    0% {
        width: 12px;
        height: 12px;
        border-radius: 100px;
    }
    100% {
        width: ${width}px;
        height: 12px;
        border-radius: 100px;
    }
`;

const shrinkToDotRight = (width: number) => keyframes`
    0% {
        width: ${width}px;
        height: 12px;
        border-radius: 100px;
    }
    100% {
        width: 12px;
        height: 12px;
        border-radius: 100px;
        transform: translateX(${width - 12}px);
    }å
`;

const moveDotToLeft = (width: number) => keyframes`
    0% {
        width: 12px;
        height: 12px;
        border-radius: 100px;
        transform: translateX(${width - 12}px);
    }
    50% {
        width: 12px;
        height: 12px;
        border-radius: 100px;
        transform: translateX(0);
    }
`;

const freezeDotOnLeft = keyframes`
    0% {
        width: 12px;
        height: 12px;
        border-radius: 100px;
    }
    100% {
        width: 12px;
        height: 12px;
        border-radius: 100px;
    }
`;

const loadAnimation = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    } 
`;

const indicatorColors = {
    AGENT: css`
        background-color: ${PRIMARY_DISABLED};
    `,
    CUSTOM_BOT: css`
        background-color: ${PRIMARY_DISABLED};
    `,
    CUSTOMER: css`
        background-color: ${POSITIVE_BASE};
    `,
    SUPERVISOR: css`
        background-color: ${PRIMARY_DISABLED};
    `,
    SYSTEM: css`
        background-color: ${PRIMARY_DISABLED};
    `,
    DISCONNECTED: css`
        background-color: ${CONTENT_DISABLED};
    `,
};

const IndicatorWrapper = styled.div`
    width: 161px;
    height: 12px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
`;

const LoadingDot = styled.div<{
    variant: number;
    indicator: MessageParticipantRole;
    duration: number;
    width: number;
}>`
    width: 12px;
    height: 12px;
    ${({ indicator }) => indicatorColors[indicator]};
    border-radius: 100px;
    position: relative;
    
    ${({ variant, duration, width }) =>
        variant === 1 &&
        css`
            animation: ${growToBarRight(width)} ${duration}ms ease-in forwards;
        `}

    ${({ variant, duration, width }) =>
        variant === 2 &&
        css`
            animation: ${shrinkToDotRight(width)} ${duration}ms ease-out forwards;
        `}

    ${({ variant, duration, width }) =>
        variant === 3 &&
        css`
            animation: ${moveDotToLeft(width)} ${duration}ms ease-in forwards;
        `}

    ${({ variant, duration }) =>
        variant === 0 &&
        css`
            animation: ${freezeDotOnLeft} ${duration}ms ease-in forwards;
        `}
`;

const LoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Loader = styled.div<{
    width: string;
    height: string;
}>`
    ::before {
        display: flex;
        width: ${({ width }) => width};
        height: ${({ height }) => height};
        margin: 0 auto;
        border: 4px solid ${PRIMARY_BASE};
        border-color: ${CONTENT_MUTED} ${CONTENT_MUTED} ${PRIMARY_BASE} ${CONTENT_MUTED};
        border-radius: 50%;
        animation: ${loadAnimation} .8s linear infinite;
        content: "";
    }
`;

export default {
    IndicatorWrapper,
    LoadingDot,
    LoadingWrapper,
    Loader
};
